import { Box, Button, Card, CardContent, CardHeader, CardMedia, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface IBasicCard {
	title: string;
	image?: string;
	subject: string;
	description: string;
	paperClasses?: string;
	contentClasses?: string;
	contentWrapperClasses?: string;
	descriptionClasses?: string;
	buttonClasses?: string;
	onClick: () => void;
	color: 'primary' | 'secondary';
}

const BasicCard: FC<IBasicCard> = ({ title, image, subject, description, color, paperClasses, descriptionClasses, buttonClasses, contentClasses, contentWrapperClasses, onClick }) => {
	const { t } = useTranslation();

	return (
		<Card className={`${color === 'primary' ? 'border-primary-main' : 'border-secondary-main'} border-1 flex flex-col rounded-lg border border-solid ${paperClasses}`}>
			<CardHeader title={t(title)} className={`${color === 'primary' ? 'bg-primary-main' : 'bg-secondary-main'} text-center text-white`} />
			{image && <CardMedia component="img" className="m-auto mb-10 mt-4 h-52 w-52" image={image} />}
			<Box className={`flex h-full flex-col justify-between p-6 ${contentWrapperClasses}`}>
				<CardContent className={`p-0 ${contentClasses}`}>
					<Typography className="mb-1 text-base text-text-primary">{subject}</Typography>
					<Typography className={`line-clamp-3 h-16 text-justify text-sm leading-5 text-text-secondary ${descriptionClasses}`}>{description}</Typography>
				</CardContent>
				<Button size="large" className={`${color === 'primary' ? 'bg-primary-main' : 'bg-secondary-main'} w-36 self-center text-background-paper ${buttonClasses}`} onClick={onClick}>
					{t('select')}
				</Button>
			</Box>
		</Card>
	);
};

export default BasicCard;
